import { setPublicPath } from 'systemjs-webpack-interop';

setPublicPath('jfrog-ui-essentials', 1);
